<template>
  <div class="pega-preview">
    <h6>■会社・職場のパーソナリティ設定</h6>
    <div
      v-for="(questions,categoryId) in getQuestionMap"
      :key="categoryId"
      class="pega-comment-block"
    >
      <preview-job-comments
        :comments="questionsCommentHighlights(categoryId-1)"
        :is-show="isShowComment"
        :data-test="`comments-${categoryId}`"
        v-on="$listeners"
      />
      <table
        class="unstriped pega-table pega-preview-table"
        :data-test="`table-${categoryId}`"
      >
        <colgroup>
          <col width="5%">
          <col width="31%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="7%">
          <col width="auto">
        </colgroup>
        <thead>
          <tr>
            <th
              colspan="7"
              :data-test="`title-${categoryId}`"
            >
              {{ categoryId | categoryTextById }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="no-border arrow-padding">
            <td colspan="2" />
            <td
              class="center"
              colspan="4"
            >
              <img
                class="arrow-color"
                src="../../assets/images/personal_yajirushi.jpg"
                alt
              >
            </td>
            <td colspan="1" />
          </tr>
          <tr class="no-border">
            <td colspan="2" />
            <td class="center">
              A
            </td>
            <td class="center">
              B
            </td>
            <td class="center">
              C
            </td>
            <td class="center">
              D
            </td>
            <td colspan="1" />
          </tr>
          <tr
            v-for="(question,questionIndex) in questions"
            :id="targetIdMap.personalityQuestion.questions[categoryId-1][questionIndex]"
            :key="questionIndex"
            class="on-border"
            :class="[{'pega-table-highlight-boss': isCompanyStaffHighlight(categoryId-1,questionIndex) }, { 'pega-table-highlight-adm': isEmployeeHighlight(categoryId-1,questionIndex) },{'pega-cursor-pen': isShowComment}]"
            :data-test="`question-${question.questionId}`"
          >
            <td
              class="center"
              :data-test="`question-id-${question.questionId}`"
            >
              {{ question.questionId }}
            </td>
            <td
              class="right"
              :data-test="`label-left-${question.questionId}`"
            >
              {{ question.labelLeft }}
            </td>
            <td
              class="center"
              :data-test="`condition-a-${question.questionId}`"
            >
              {{ toSign("A",question.condition) }}
            </td>
            <td
              class="center"
              :data-test="`condition-b-${question.questionId}`"
            >
              {{ toSign("B",question.condition) }}
            </td>
            <td
              class="center"
              :data-test="`condition-c-${question.questionId}`"
            >
              {{ toSign("C",question.condition) }}
            </td>
            <td
              class="center"
              :data-test="`condition-d-${question.questionId}`"
            >
              {{ toSign("D",question.condition) }}
            </td>
            <td
              :id="getId(categoryId-1,questionIndex)"
              :data-test="`label-right-${question.questionId}`"
            >
              {{ question.labelRight }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import _ from 'lodash'

export default {
  components: {
    PreviewJobComments
  },
  filters: {
    categoryTextById (val) {
      if (val === '1') {
        return '会社・職場の環境、雰囲気について近い方を選択してください。'
      } else if (val === '2') {
        return 'この求人に合う性格、考え方、行動スタイルに近い方を選択してください。'
      } else if (val === '3') {
        return 'この求人に合う仕事スタイルに近い方を選択してください。'
      } else {
        return ''
      }
    }
  },
  mixins: [jobPreviewCommon],
  props: {
    personalityMatching: {
      type: Array,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      highlightIdMap: {}
    }
  },
  computed: {
    getQuestionMap () {
      return _.groupBy(this.personalityMatching, o => o.categoryId)
    }
  },
  watch: {
    commentHighlights: {
      handler: 'setHighlightForPersonaMatching'
    }
  },
  mounted () {
    this.setHighlightForPersonaMatching()
  },
  methods: {
    toSign (expected, actual) {
      return expected === actual ? '●' : ''
    },
    questionsCommentHighlights (index) {
      const regexp = new RegExp('^(' + this.targetIdMap.personalityQuestion.questions[index].join('|') + ')')

      return this.commentHighlights
        .filter(commentHighlight => regexp.test(commentHighlight.target))
    },
    setHighlightForPersonaMatching () {
      this.highlightIdMap = {}
      this.commentHighlights
        .filter(commentHighlight => commentHighlight.target.startsWith(this.targetIdMap.personalityQuestion.prefix))
        .forEach((commentHighlight) => {
          if (!commentHighlight.highlight) return // ハイライト情報がない場合は処理不要
          const id = this.createHighlightId(commentHighlight.target, commentHighlight.highlight.start)
          this.$set(this.highlightIdMap, commentHighlight.target, { id: id, isCompanyStaff: commentHighlight.isCompanyStaff })
        })
    },
    getId (index1, index2) {
      const target = this.highlightIdMap[this.targetIdMap.personalityQuestion.questions[index1][index2]]
      return target ? target.id : null
    },
    isCompanyStaffHighlight (index1, index2) {
      const target = this.highlightIdMap[this.targetIdMap.personalityQuestion.questions[index1][index2]]
      return target ? target.isCompanyStaff : false
    },
    isEmployeeHighlight (index1, index2) {
      const target = this.highlightIdMap[this.targetIdMap.personalityQuestion.questions[index1][index2]]
      return target ? !target.isCompanyStaff : false
    }
  }
}
</script>
